import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { FetchMonthlyTourProgramType } from "../../../domain/models/monthly-tour-program/fetch-monthly-tour-program";
import { RemoteFetchMonthlyTourProgram } from "../../../data/usecases/monthly-tour-program/remote-fetch-monthly-tour-program";

export interface FetchMonthlyTourProgramInterface {
  FetchMonthlyTourProgram: FetchMonthlyTourProgramType;
  FetchMonthlyTourProgramState: FetchState;
  fetchMonthlyTourProgram: Function;
}

const initialStates = {
  FetchMonthlyTourProgram: {} as FetchMonthlyTourProgramType,
  FetchMonthlyTourProgramState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchMonthlyTourProgramSlice: StateCreator<
  FetchMonthlyTourProgramInterface
> = (set) => ({
  ...initialStates,
  fetchMonthlyTourProgram: async (
    month: number,
    year: number,
  ) => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchMonthlyTourProgram = new RemoteFetchMonthlyTourProgram(
      `${BASE_URL}${Endpoints.FETCH_MONTHLY_TOUR_PROGRAM}`,
      axiosHttpClient
    );

    set(() => ({ FetchMonthlyTourProgramState: FetchState.LOADING }));
    let result = await remoteFetchMonthlyTourProgram.fetch(month, year);
    return result;
  },
});
